import { render } from "./pwa-update-popup.vue?vue&type=template&id=59c981a1&scoped=true"
import script from "./pwa-update-popup.vue?vue&type=script&lang=js"
export * from "./pwa-update-popup.vue?vue&type=script&lang=js"

import "./pwa-update-popup.vue?vue&type=style&index=0&id=59c981a1&scoped=true&lang=css"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c981a1"]])

export default __exports__